import { urlForImage } from '@/sanity/lib/image'
import Image from 'next/image'

const TitleIcon = ({ icon }) => {
  const base = 'relative w-[50px] h-[50px] lg:w-[100px] lg:h-[100px] shrink-0'

  return (
    <div className={base}>
      <Image
        src={urlForImage(icon).url()}
        alt={icon.alt}
        fill
        placeholder="blur"
        blurDataURL={icon.metadata.lqip}
        className="object-contain"
      />
    </div>
  )
}

export default TitleIcon
